module.exports = __webpack_public_path__ + "static/img/charm_level_89.3720942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_89.png
// module id = Xc/i
// module chunks = 0